import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

@Component({
  selector: 'general-select',
  templateUrl: './general-select.component.html',
  styleUrl: './general-select.component.scss'
})
export class GeneralSelectComponent implements OnInit {

  @Input() form!: FormGroup;
  @Input() controlName!: string;
  @Input() options: SelectOption[] = [];
  @Input() label!: string;
  @Input() placeholder: string = 'Seleccione una opción';
  @Input() isDisabled: boolean = false;
  @Input() isReadOnly: boolean = false;
  @Input() isReFill: boolean = false;
  @Input() defaultValue: string = 'C'; // Valor por defecto configurable
  @Input() showPlaceholder: boolean = true; // Mostrar opción placeholder

  constructor() { }

  ngOnInit(): void {
    this.initializeDefaultOptions();
    this.setDefaultValue();
  }

  private initializeDefaultOptions(): void {
    // Si no se proporcionan opciones, usar las opciones por defecto
    if (!this.options || this.options.length === 0) {
      this.options = [
        { value: 'C', label: 'Cédula de ciudadanía' },
        // { value: 'E', label: 'Cédula de extranjería' },
        // { value: 'P', label: 'Pasaporte' },
        // { value: 'T', label: 'Tarjeta de identidad' }
      ];
    }
  }

  private setDefaultValue(): void {
    const control = this.form.get(this.controlName);
    
    if (control && (control.value === null || control.value === undefined || control.value === '')) {
      // Verificar si el valor por defecto existe en las opciones
      const defaultExists = this.options.some(option => option.value === this.defaultValue);
      
      if (defaultExists) {
        control.setValue(this.defaultValue);
      } else if (this.options.length > 0) {
        // Si el valor por defecto no existe, usar la primera opción disponible
        control.setValue(this.options[0].value);
      }
    }
  }

  // Método para obtener el label de la opción seleccionada
  getSelectedLabel(): string {
    const control = this.form.get(this.controlName);
    if (control && control.value) {
      const selectedOption = this.options.find(option => option.value === control.value);
      return selectedOption ? selectedOption.label : '';
    }
    return '';
  }

  // Método para verificar si una opción está deshabilitada
  isOptionDisabled(option: SelectOption): boolean {
    return option.disabled || false;
  }
}